import React from 'react';
import CategoriesQualityView from './CategoriesQualityView';
import styles from './CategoriesQualityView.module.css';

interface ErrorBoundaryState {
  hasError: boolean;
  message?: string;
}

class CategoriesErrorBoundary extends React.Component<{ children: React.ReactNode }, ErrorBoundaryState> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    const message = error instanceof Error ? error.message : 'An unexpected error occurred.';
    return { hasError: true, message };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    console.error('CategoriesQualityRoute error boundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.errorBanner} role="alert">
          <div className={styles.errorBannerTitle}>A panel failed to render.</div>
          <div className={styles.errorBannerBody}>{this.state.message}</div>
        </div>
      );
    }
    return this.props.children;
  }
}

interface CategoriesQualityRouteProps {
  className?: string;
}

const CategoriesQualityRoute: React.FC<CategoriesQualityRouteProps> = ({ className = '' }) => {
  return (
    <CategoriesErrorBoundary>
      <CategoriesQualityView className={className} />
    </CategoriesErrorBoundary>
  );
};

export default CategoriesQualityRoute;
